export enum LocalStorageKey {
  CURRENT_PROJECT = 'currentProject',
  SESSION_ID = 'session_id',
  USER_ROLE = 'user_role'
}
